import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";
import { generalErrorCodes } from "shared/errors/generalErrorCodes";
import { TFunction } from "i18next";

export interface MutateFinishRegistrationParams {
  userId: number;
  token: string;
}

export const mutateFinishRegistration = async (values: MutateFinishRegistrationParams) => {
  const response = await makeMutation(ApiEndpoints.userFinishRegistration(), values, false, 'POST', finishRegistrationErrorCodes);
  return { success: response.success };
};

export const finishRegistrationErrorCodes = {
  ...generalErrorCodes,
  INVALID_TOKEN: {
    code: "INVALID_TOKEN",
    translation: (t: TFunction) => t("finishRegistration.INVALID_TOKEN"),
  },
};
